export default class HttpClient {
  constructor(basePath) {
    this._basePath = basePath
    this._headerTransformers = []
  }

  addTransformer(transformer) {
    this._headerTransformers.push(transformer)
  }

  setClientCredentials(clientId, clientSecret) {
    this._clientId = clientId
    this._clientSecret = clientSecret
  }

  async get(path, includeCredentials) {
    let options = {
      method: 'GET',
      headers: await this._createHeaders()
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async post(path, body, includeCredentials) {
    let options = {
      method: 'POST',
      headers: await this._createHeaders(),
      body: JSON.stringify(body)
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async patch(path, body, includeCredentials) {
    let options = {
      method: 'PATCH',
      headers: await this._createHeaders(),
      body: JSON.stringify(body)
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async put(path, body, includeCredentials) {
    let options = {
      method: 'PUT',
      headers: await this._createHeaders(),
      body: JSON.stringify(body)
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async delete(path, includeCredentials) {
    let options = {
      method: 'DELETE',
      headers: await this._createHeaders()
    }

    return this.sendRequest(path, options, includeCredentials)
  }

  async sendRequest(path, options, includeCredentials) {
    if (includeCredentials) {
      options.credentials = 'include'
    }

    return fetch(this._basePath + path, options)
  }

  setTokens(accessToken, refreshToken) {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
  }

  async _createHeaders() {
    let headers = new Headers({
      'Content-Type': 'application/json'
    })

    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      headers.append('Authorization', `Bearer ${accessToken}`)
    }

    for (let transformer of this._headerTransformers) {
      headers = await transformer.transform(headers)
    }

    return headers
  }

  async getOAuthAccessToken() {
    try {
      const formdata = new FormData()
      formdata.append('grant_type', 'client_credentials')

      const response = fetch(`${this._basePath}/oauth/token`, {
        method: 'post',
        headers: {
          Authorization: `Basic ${Buffer.from(`${this._clientId}:${this._clientSecret}`).toString('base64')}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formdata
      })

      const responseJson = await response.json()
      return responseJson.access_token
    } catch (error) {
      throw error
    }
  }
}
